module.exports = __webpack_public_path__ + "static/img/page_17.480861ed.png";